// extracted by mini-css-extract-plugin
export default {"holder":"ErrorLine_holder__kwLJi","holder__inner":"ErrorLine_holder__inner__RvTqN","msg":"ErrorLine_msg__IBz0d","msg__close":"ErrorLine_msg__close__CQUkw"};